import React from "react";
import { connect } from "react-redux";
import { fetchReconciliation } from "../../queries/reconciliation/reconciliationQuery";
import language from "../../language";
import { Table } from "../Table";
import { Modal } from "../Modal";
import icons from "../../constants/icons";
import { getStorage } from "../../utils/storage";
import ProcessReport from "./ProcessReport";
import Settlements from "./Settlements";
import Activities from "./Activities";

class Reconciliation extends React.Component {
  state = {
    isLoading: false,
    selectedData: {},
    data: [],
    page: 0,
    limit: 10,
  };

  componentDidMount() {
    this.getData(true);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters !== this.props.filters) {
      this.setState({ page: 0 }, () => {
        this.getData(true);
      });
    }
  }

  filtersParams = async () => {
    let { filters = {} } = this.props;
    const { page, limit } = this.state;

    const { merchantID } = await getStorage("merchantID");

    let params = {
      merchantId: merchantID,
      page,
      size: limit,
    };

    if (filters.transactionStatus) {
      params.transactionResult = filters.transactionStatus.value;
    }

    if (filters.paymentMode) {
      params.paymentMode = filters.paymentMode.value;
    }

    if (filters.startDate && filters.endDate) {
      params.startDate = filters.startDate;
      params.endDate = filters.endDate;
    }

    if (filters.transactionSubType) {
      params.transactionSubType = filters.transactionSubType.value;
    }
    return params;
  };

  getData = async (isLoading) => {
    const { defaultLanguage } = this.props;
    const params = await this.filtersParams();

    try {
      this.setState({ isLoading });

      const data = await fetchReconciliation(defaultLanguage, params);

      this.setState({
        isLoading: false,
        data: data.content,
        totalPageCount: data.totalPages,
        page: data.number,
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  handlePagination(page) {
    this.setState(
      {
        page,
      },
      () => {
        this.getData(true);
      }
    );
  }

  handleShowModal(modal, modalTitle, selectedData = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selectedData,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].run_number,
        key: "runNumber",
        type: "link",
        onPress: (item) =>
          this.handleShowModal("showModal", "Merchant Statement Summary", item),
      },
      {
        title: language[this.props.defaultLanguage].transaction_date,
        key: "transactionDate",
      },
      {
        title: language[this.props.defaultLanguage].label,
        key: "label",
      },
      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
      },

      {
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      },
    ];

    return headers;
  }

  render() {
    return (
      <>
        <Table
          data={this.state.data}
          page={this.state.page}
          limit={this.state.limit}
          addButtonText={language[this.props.defaultLanguage].add_collection}
          totalPageCount={this.state.totalPageCount}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
          filters={[
            {
              title: language[this.props.defaultLanguage].date_range,
              button_type: "dropdown",
              icon: icons.calendar,
              filterName: "date",
            },
          ]}
          actions={[
            {
              name: language[this.props.defaultLanguage].view,
              onPress: (item) => this.handleShowModal("showModal", "", item),
              icon: icons.visibility,
            },
            {
              name: language[this.props.defaultLanguage].settlements,
              onPress: (item) =>
                this.handleShowModal("showSettlementsModal", "", item),
            },
            {
              name: language[this.props.defaultLanguage].activities,
              onPress: (item) =>
                this.handleShowModal("showActivitiesModal", "", item),
            },
          ]}
        />
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          // title={this.state.modalTitle}
          showHeaderBottomBorder={false}
          size="lg"
          title=""
        >
          <ProcessReport
            reconciliationPublicId={this.state.selectedData.publicId}
          />
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showSettlementsModal")}
          show={this.state.showSettlementsModal}
          showHeaderBottomBorder={false}
          size="xl"
          title={language[this.props.defaultLanguage].settlements}
        >
          <Settlements
            reconciliationPublicId={this.state.selectedData.publicId}
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showSettlementsModal"
            )}
          />
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showActivitiesModal")}
          show={this.state.showActivitiesModal}
          showHeaderBottomBorder={false}
          size="lg"
          title={language[this.props.defaultLanguage].activities}
        >
          <Activities
            reconciliationPublicId={this.state.selectedData.publicId}
          />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { filters } = state.Filters;
  return {
    defaultLanguage,
    filters,
  };
};

export default connect(mapStateToProps)(Reconciliation);
